import {ar} from './ar.json'
var i18n = {}
i18n.ar = ar;

window.i18n = i18n;

const t = function (key) {

  const language = $.cookie('language') || "en";

  if (i18n[language] && i18n[language][key]) {
    return i18n[language][key]
  }
  else {
    return key.replace(/_/g, ' '); //returns self stringified
  }
}
window.t = t;

export default t;